export const GET_APPROVAL_CENTER_CALL = 'GET_APPROVAL_CENTER_CALL';
export const GET_APPROVAL_CENTER_DONE = 'GET_APPROVAL_CENTER_DONE';
export const GET_APPROVAL_CENTER_FAIL = 'GET_APPROVAL_CENTER_FAIL';
